'use client';

import React, { FC, ReactNode, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import clsx from 'clsx';

type Props = {
  in: boolean;
  children: ReactNode;
  className?: string;
  timeout?: number;
};

const AnimateHeight: FC<Props> = ({ in: inProp, children, className, timeout = 300 }) => {
  const nodeRef = useRef<HTMLDivElement | null>(null);

  const onEnter = () => {
    if (nodeRef.current) {
      nodeRef.current.style.height = '0px';
      nodeRef.current.style.opacity = '0';
    }
  };

  const onEntering = () => {
    if (nodeRef.current) {
      const scrollHeight = nodeRef.current.scrollHeight;
      nodeRef.current.style.height = `${scrollHeight}px`;
      nodeRef.current.style.opacity = '1';
      nodeRef.current.style.transition = `height ${timeout}ms, opacity ${timeout}ms`;
    }
  };

  const onEntered = () => {
    if (nodeRef.current) {
      nodeRef.current.style.height = 'auto';
    }
  };

  const onExit = () => {
    if (nodeRef.current) {
      const scrollHeight = nodeRef.current.scrollHeight;
      nodeRef.current.style.height = `${scrollHeight}px`;
      nodeRef.current.style.opacity = '1';
    }
  };

  const onExiting = () => {
    if (nodeRef.current) {
      nodeRef.current.style.transition = `height ${timeout}ms, opacity ${timeout}ms`;
      nodeRef.current.style.height = '0px';
      nodeRef.current.style.opacity = '0';
    }
  };

  return (
    <CSSTransition
      in={inProp}
      nodeRef={nodeRef}
      timeout={timeout}
      unmountOnExit
      onEnter={onEnter}
      onEntering={onEntering}
      onEntered={onEntered}
      onExit={onExit}
      onExiting={onExiting}
    >
      <div ref={nodeRef} className={clsx(className)}>
        {children}
      </div>
    </CSSTransition>
  );
};

export { AnimateHeight };
